import Accordions from "./accordions";

class Header {
  selectors = {
    mainNavigation: '[data-header="main-navigation"]',
    navItem: '[data-header="nav-item"]',
    navItemMobile: '[data-header="nav-item-mobile"]',
    link: '[data-header="link"]',
    flyoutItem: '[data-header="flyout-item"]',
    metaItem: '[data-header="meta-item"]',
    // accordion: '[data-accordion="el"]',
  };

  stateClasses = {
    header: {
      flyoutOpen: "header--flyout-open",
    },
    navItem: {
      flyoutOpen: "main-navigation__item--flyout-open",
      active: "main-navigation__item--active",
    },
    flyoutItem: {
      active: "flyout-navigation__item--active",
    },
    metaItem: {
      active: "meta-navigation__item--active",
    },
  };

  constructor($el) {
    this.$el = $el;
    this.$mainNavigation = $el.find(this.selectors.mainNavigation);
    this.$navItems = $el.find(this.selectors.navItem);
    this.$navItemsMobile = $el.find(this.selectors.navItemMobile);
    this.$flyoutItems = $el.find(this.selectors.flyoutItem);
    this.$metaItems = $el.find(this.selectors.metaItem);
    this.$accordions = $el;
    // this.$accordions = $el.find(this.selectors.accordion);

    this.init();
  }

  init = () => {
    this.$navItems.on("mouseenter", this.mouseEnterHandler);
    this.$navItems.on("mouseleave", this.mouseLeaveHandler);

    // init accordions
    this.accordions = new Accordions(this.$accordions);
    // this.$accordions.each((index, el) => {
    //   new Accordion($(el));
    // });
  };

  mouseEnterHandler = (e) => {
    const $navItem = $(e.currentTarget);
    this.openFlyout($navItem);
  };

  openFlyout = ($navItem) => {
    this.$el.addClass(this.stateClasses.header.flyoutOpen);
    $navItem.addClass(this.stateClasses.navItem.flyoutOpen);

    // close flyout when esc is pressed
    $(document).on("keyup", this.closeFlyout);
  };

  closeFlyout = () => {
    this.$navItems.removeClass(this.stateClasses.navItem.flyoutOpen);
    this.$el.removeClass(this.stateClasses.header.flyoutOpen);

    // remove event listener
    $(document).off("keyup", this.closeFlyout);
  };

  mouseLeaveHandler = (e) => {
    this.closeFlyout();
  };

  setActiveLink = (cat, entry) => {
    const $activeNavItem = this.$navItems.filter(`[data-cat="${cat}"]`);
    const $activeNavItemMobile = this.$navItemsMobile.filter(
      `[data-cat="${cat}"]`
    );
    const $activeFlyoutItem = this.$flyoutItems.filter(
      `[data-entry="${entry}"]`
    );
    const $activeMetaItem = this.$metaItems.filter(`[data-entry="${entry}"]`);

    // reset active classes
    this.$navItems.removeClass(this.stateClasses.navItem.active);
    this.$navItemsMobile.removeClass(this.stateClasses.navItem.active);
    this.$flyoutItems.removeClass(this.stateClasses.flyoutItem.active);
    this.$metaItems.removeClass(this.stateClasses.metaItem.active);

    if ($activeNavItemMobile) {
      $activeNavItemMobile.addClass(this.stateClasses.navItem.active);
    }

    if ($activeNavItem) {
      $activeNavItem.addClass(this.stateClasses.navItem.active);
    }

    if ($activeFlyoutItem) {
      $activeFlyoutItem.addClass(this.stateClasses.flyoutItem.active);
    }

    if ($activeMetaItem) {
      $activeMetaItem.addClass(this.stateClasses.metaItem.active);
    }
  };

  closeALlAccordions = () => {
    this.accordions.closeAll();
  };
}

export default Header;
